
import { DetailController } from "./controllers/detailController";
import "../../../../../core/directives/readOnlyText/readOnlyTextDirective";



export class DetailDirective implements angular.IDirective {
    template = require('./templates/detail.html');
    restrict = 'E';
    controller = DetailController;
    controllerAs = 'vm';
    bindToController = {
        requestDetail: '=requestDetail'
       
    };
    scope = {};

    static factory(): angular.IDirectiveFactory {
        return () => new DetailDirective();
    }
}

angular.module('deliveryCreate.app').directive("detail", DetailDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/directives/detail/detailDirective.ts
 **/